const ServiceArea = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-black mb-4">Service Area</h2>
          <p className="text-lg text-gray-600">
            Proudly serving Western North Carolina, North Georgia, and Southwest South Carolina
          </p>
        </div>

        <div className="bg-gray-100 rounded-3xl overflow-hidden shadow-2xl border-4 border-yellow-500">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3287.8!2d-83.3897!3d35.0542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885913c5e5e5e5e5%3A0x5e5e5e5e5e5e5e5e!2sOtto%2C%20NC%2028763!5e0!3m2!1sen!2sus!4v1234567890"
            width="100%"
            height="600"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Service Area Map"
          ></iframe>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          <div className="bg-gray-50 p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-fill text-black text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-black mb-2">Western North Carolina</h3>
            <p className="text-gray-600 text-sm">
              Otto, Bryson City, Franklin, Highlands, Cashiers, and surrounding areas
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-fill text-black text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-black mb-2">North Georgia</h3>
            <p className="text-gray-600 text-sm">
              Clayton, Blue Ridge, Hiawassee, and nearby communities
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-fill text-black text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-black mb-2">Southwest South Carolina</h3>
            <p className="text-gray-600 text-sm">
              Serving select areas in the southwestern region
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;